module.exports = __webpack_public_path__ + "img/calendar-arrow-to.cd2bac59.svg";